import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import axios from 'axios';
import utils from 'utility';

// Externals
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import validate from 'validate.js';
import _ from 'underscore';
// Material helpers
import { withStyles } from '@material-ui/styles';
import SnackbarsMessage from '../../components/SnackbarsMessage';

// Material components
import {
    Button,
    Checkbox,
    CircularProgress,
    Grid,
    IconButton,
    TextField,
    Typography
} from '@material-ui/core';

// Material icons
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import ServiceDialog from './ServiceDialog';
// Shared utilities
import validators from 'common/validators';
import Http from 'services/http';

// Component styles
import styles from './styles';

// Form validation schema
import schema from './schema';

// Shared components

validate.validators.checked = validators.checked;

// Service methods

class SignUp extends Component {
    state = {
        values: {
            mobile: '',
            captcha: '',
            password: '',
            comfirmPassword: '',
            policy: false
        },
        touched: {
            mobile: false,
            captcha: false,
            password: false,
            comfirmPassword: false,
            policy: null
        },
        errors: {
            mobile: null,
            captcha: null,
            password: null,
            comfirmPassword: null,
            policy: null
        },
        isValid: false,
        isLoading: false,
        submitError: null,
        isSend: false,
        snackbarsMsg: '',
        snackbarsVisible: false,
        issendcount: 120,
        validPasswordError: true,
        open: false
    };

    async componentDidMount() {
        try {
            let resData = await Http.session_check();
            if (resData && resData.errcode !== 0) {
                localStorage.clear();
            } else {                
                JSON.parse(localStorage.getItem('cur_cpy'))?this.props.history.push('/users'):this.props.history.push('/newuser')        
            }
        }catch (err) {
            localStorage.clear();
        }
    }

    showMsg = msg => {
        this.setState({
            snackbarsMsg: msg,
            snackbarsVisible: true
        });
        setTimeout(() => {
            this.setState({
                snackbarsMsg: '',
                snackbarsVisible: false
            });
        }, 2000);
    };
    handleSnackBarsClose = () => {
        this.setState({
            snackbarsVisible: false
        });
    };
    handleBack = () => {
        const { history } = this.props;

        history.goBack();
    };

    validateForm = () => {
        const { values } = this.state;

        const newState = { ...this.state };
        const errors = validate(values, schema);
        newState.isValid = errors ? false : true;
        newState.errors = errors || {};

        this.setState(newState, () => {
            if (
                newState.values['password'] ===
                    newState.values['comfirmPassword'] &&
                newState.touched['password'] &&
                newState.touched['comfirmPassword']
            ) {
                this.setState({
                    validPasswordError: true
                });
            } else if (newState.touched['password']) {
                this.setState({
                    validPasswordError: false
                });
            }
        });
    };

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState.submitError = null;
        newState.touched[field] = true;
        newState.values[field] = value;
        this.setState(newState, this.validateForm);
    };

    handleSignUp = async () => {
        try {
            const { history } = this.props;
            const { values } = this.state;

            this.setState({ isLoading: true });

            const res = await Http.reg({
                phone: values.mobile,
                // email: values.mobile,
                verify: values.captcha,
                password: utils.md5(values.password)
            });
            const { errcode, errmsg } = res;
            if (errcode === 0) {
                this.showMsg('注册成功，请登录进入');
                setTimeout(() => {
                    this.setState({
                        isLoading: false
                    });
                    history.push('/sign-in');
                }, 1000);
            } else {
                this.setState({
                    isLoading: false
                });
                this.showMsg(errmsg);
            }
        } catch (error) {
            this.setState({
                isLoading: false
            });
        }
    };

    handleGetCaptcha = () => {
        const { values } = this.state;
        this.setState({
            isSend: true
        });
        setTimeout(() => {
            this.setState({
                isSend: false
            });
        }, 1000 * 120);
        let timer = setInterval(() => {
            const { issendcount } = this.state;
            if (issendcount === 0) {
                clearInterval(timer);
                this.setState({
                    issendcount: 120
                });
            } else {
                this.setState({
                    issendcount: issendcount - 1
                });
            }
        }, 1000);

        // 请求验证码
        axios
            .get(`/Handler/Captcha.ashx?type=pageyzm&phone=${values.mobile}`)
            .then(res => {
                const { errcode, errmsg } = res.data;
                if (errcode !== 0) {
                    this.setState({
                        isSend: false
                    });
                    this.showMsg(errmsg);
                } else {
                    this.showMsg('发送成功');
                }
            })
            .catch(error => {
                console.log(error);
            });
    };

    serviceInfo = () => {
        this.setState({
            open: !this.state.open
        });
    };

    render() {
        const { classes } = this.props;
        const {
            values,
            touched,
            errors,
            isValid,
            submitError,
            isLoading
        } = this.state;

        const showmobileError =
            touched.mobile && errors.mobile ? errors.mobile[0] : false;
        const disableGetCaptcha = touched.mobile
            ? errors.mobile
                ? true
                : false
            : true;
        const showcaptchaError =
            touched.captcha && errors.captcha ? errors.captcha[0] : false;
        const showpasswordError =
            touched.password && errors.password ? errors.password[0] : false;
        const showcomfirmPasswordError =
            touched.comfirmPassword && errors.comfirmPassword
                ? errors.comfirmPassword[0]
                : false;
        const showPolicyError =
            touched.policy && errors.policy ? errors.policy[0] : false;

        return (
            <div className={classes.root}>
                <SnackbarsMessage
                    handleClose={this.handleSnackBarsClose}
                    msg={this.state.snackbarsMsg}
                    visible={this.state.snackbarsVisible}
                />
                <Grid className={classes.grid} container>
                    <Grid className={classes.quoteWrapper} item lg={5}>
                        <div className={classes.quote}>
                            {/* <div className={classes.quoteInner}>
                <Typography
                    className={classes.quoteText}
                    variant="h1"
                >
                  叮咚科技，掌握美好未来
                </Typography>
                <div className={classes.person}>
                  <Typography
                      className={classes.name}
                      variant="body1"
                  >
                  </Typography>
                  <Typography
                      className={classes.bio}
                      variant="body2"
                  >
                  </Typography>
                </div>
              </div> */}
                        </div>
                    </Grid>
                    <Grid className={classes.content} item lg={7} xs={12}>
                        <div className={classes.content}>
                            <div className={classes.contentHeader}>
                                <IconButton
                                    className={classes.backButton}
                                    onClick={this.handleBack}
                                >
                                    <ArrowBackIcon />
                                </IconButton>
                            </div>
                            <div className={classes.contentBody}>
                                <div className={classes.form}>
                                    <Typography
                                        className={classes.title}
                                        variant="h2"
                                    >
                                        叮咚科技，掌握美好未来
                                    </Typography>
                                    <Typography
                                        className={classes.subtitle}
                                        variant="body1"
                                    >
                                        新建账号
                                    </Typography>
                                    <div className={classes.fields}>
                                        <div className={classes.textField}>
                                            <TextField
                                                className={
                                                    classes.textCaptchaField
                                                }
                                                label="手机号码"
                                                name="mobile"
                                                onChange={event =>
                                                    this.handleFieldChange(
                                                        'mobile',
                                                        event.target.value
                                                    )
                                                }
                                                value={values.mobile}
                                                variant="outlined"
                                            />
                                            <Button
                                                className={
                                                    classes.textCaptchaButton
                                                }
                                                disabled={
                                                    disableGetCaptcha ||
                                                    this.state.isSend
                                                }
                                                onClick={this.handleGetCaptcha}
                                                variant="contained"
                                            >
                                                {this.state.isSend
                                                    ? this.state.issendcount
                                                    : '获取验证码'}
                                            </Button>
                                        </div>
                                        {showmobileError && (
                                            <Typography
                                                className={classes.fieldError}
                                                variant="body2"
                                            >
                                                {errors.mobile[0].replace(
                                                    'Mobile',
                                                    ''
                                                )}
                                            </Typography>
                                        )}
                                        <TextField
                                            className={classes.textField}
                                            inputProps={{
                                                autoComplete: 'new-password',
                                                form: {
                                                    autoComplete: 'off'
                                                }
                                            }}
                                            label="验证码"
                                            onChange={event =>
                                                this.handleFieldChange(
                                                    'captcha',
                                                    event.target.value
                                                )
                                            }
                                            value={values.captcha}
                                            variant="outlined"
                                        />
                                        {showcaptchaError && (
                                            <Typography
                                                className={classes.fieldError}
                                                variant="body2"
                                            >
                                                {errors.captcha[0].replace(
                                                    'Captcha',
                                                    ''
                                                )}
                                            </Typography>
                                        )}
                                        <TextField
                                            className={classes.textField}
                                            inputProps={{
                                                autoComplete: 'new-password',
                                                form: {
                                                    autoComplete: 'off'
                                                }
                                            }}
                                            label="密码"
                                            name="password"
                                            onChange={event =>
                                                this.handleFieldChange(
                                                    'password',
                                                    event.target.value
                                                )
                                            }
                                            type="password"
                                            value={values.password}
                                            variant="outlined"
                                        />
                                        {showpasswordError && (
                                            <Typography
                                                className={classes.fieldError}
                                                variant="body2"
                                            >
                                                {errors.password[0].replace(
                                                    'Password',
                                                    ''
                                                )}
                                            </Typography>
                                        )}
                                        <TextField
                                            className={classes.textField}
                                            inputProps={{
                                                autoComplete: 'new-password',
                                                form: {
                                                    autoComplete: 'off'
                                                }
                                            }}
                                            label="确认密码"
                                            onChange={event =>
                                                this.handleFieldChange(
                                                    'comfirmPassword',
                                                    event.target.value
                                                )
                                            }
                                            type="password"
                                            value={values.comfirmPassword}
                                            variant="outlined"
                                        />
                                        {showcomfirmPasswordError && (
                                            <Typography
                                                className={classes.fieldError}
                                                variant="body2"
                                            >
                                                {errors.comfirmPassword[0].replace(
                                                    'Comfirm password',
                                                    ''
                                                )}
                                            </Typography>
                                        )}
                                        {!this.state.validPasswordError && (
                                            <Typography
                                                className={classes.fieldError}
                                                variant="body2"
                                            >
                                                两次输入的不一致
                                            </Typography>
                                        )}
                                        <div className={classes.policy}>
                                            <Checkbox
                                                checked={values.policy}
                                                className={
                                                    classes.policyCheckbox
                                                }
                                                color="primary"
                                                name="policy"
                                                onChange={() =>
                                                    this.handleFieldChange(
                                                        'policy',
                                                        !values.policy
                                                    )
                                                }
                                            />
                                            <Typography
                                                className={classes.policyText}
                                                variant="body1"
                                            >
                                                我已阅读，并同意
                                                {/* <Link
                                                    className={
                                                        classes.policyUrl
                                                    }
                                                    onClick={this.serviceInfo}
                                                    to="#"
                                                >
                                                    叮咚签到平台服务协议
                                                </Link> */}
                                                <a href="https://dingdong.beevle.cn/protocol/ddservice.html" target="_blank">《叮咚签到平台服务协议》</a>
                                                和<a href="https://dingdong.beevle.cn/protocol/ddprivacy.html" target="_blank">《叮咚签到用户隐私协议》</a>
                                            </Typography>
                                        </div>
                                        {showPolicyError && (
                                            <Typography
                                                className={classes.fieldError}
                                                variant="body2"
                                            >
                                                {errors.policy[0].replace(
                                                    'Policy',
                                                    ''
                                                )}
                                            </Typography>
                                        )}
                                    </div>
                                    {submitError && (
                                        <Typography
                                            className={classes.submitError}
                                            variant="body2"
                                        >
                                            {submitError}
                                        </Typography>
                                    )}
                                    {isLoading ? (
                                        <CircularProgress
                                            className={classes.progress}
                                        />
                                    ) : (
                                        <Button
                                            className={classes.signUpButton}
                                            color="primary"
                                            disabled={!isValid}
                                            onClick={this.handleSignUp}
                                            size="large"
                                            variant="contained"
                                        >
                                            注册
                                        </Button>
                                    )}
                                    <Typography
                                        className={classes.signIn}
                                        variant="body1"
                                    >
                                        已经有账号了?{' '}
                                        <Link
                                            className={classes.signInUrl}
                                            to="/sign-in"
                                        >
                                            登录
                                        </Link>
                                    </Typography>
                                </div>
                            </div>
                            <Grid  style={{paddingLeft:'50px', paddingBottom:'20px'}}>
                            <Typography className={classes.company} variant="body1">
                                    © 2015 - 2026 山东比威信息技术有限公司 版权所有 (<a href="https://beian.miit.gov.cn" target="_blank">鲁ICP备16018113号-3</a>)
                            </Typography>  
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
                {/* <ServiceDialog
                    open={this.state.open}
                    handleClose={this.serviceInfo}
                /> */}
            </div>
        );
    }
}

SignUp.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};

export default compose(
    withRouter,
    withStyles(styles)
)(SignUp);
